import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

//components
import SwitchWidget from '../../Admin/ControlPanel/SwitchWidget.js';
import Button from '../../../components/CustomButton/CustomButton.jsx';

//utils
import { modulePermissionsMap } from '../../../utils/constants.js';
import { checkCircleSVG, crossCircleSVG, saveSVG, editSVG, backSVG } from '../../../utils/constants';

const RosterPermissionsTab = ({ t, modulePermissions, currentId, currentPermission, onEdit, onSave, onCancel, onPermissionChange }) => {
    const rosterModules = Object.keys(modulePermissionsMap).map(key => modulePermissions.find(ele => ele.module === key)).filter(Boolean);

    return (
        <div className="row mt-1">
            <div className="col-12 mb-2">
                <span className="font-size-11 text-muted">
                    <i className="fa fa-info-circle me-1"></i>
                    {t('Note')} : {t('Some roster features require Roster View. It will be enabled automatically when needed.')}
                </span>
            </div>
            {rosterModules.map((ele, index) => {
                const config = modulePermissionsMap[ele.module];
                const isEditing = currentId === ele.module;
                const colClass = rosterModules.length <= 2 ? 'col-md-6' : 'col-md-4';
                const displayedPerms = config.permissions.filter(perm => perm.value in ele.permissions);
                return (
                    <div key={`roster_card_${index}`} className={`${colClass} mb-3 d-flex`}>
                        <div className="card h-100 w-100 shadow-sm">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <span className="fw-bold">{t(config.label)}</span>
                                <div>
                                    {isEditing ? (
                                        <>
                                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">{t('Update Permissions')}</Tooltip>}>
                                                <Button icon_sm fill onClick={onSave}>
                                                    {saveSVG({ width: 20, fillColor: '#2550AC' })}
                                                </Button>
                                            </OverlayTrigger>
                                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">{t('Cancel')}</Tooltip>}>
                                                <Button icon_sm fill ms2 onClick={onCancel}>
                                                    {backSVG({ width: 20, fillColor: '#2550AC' })}
                                                </Button>
                                            </OverlayTrigger>
                                        </>
                                    ) : (
                                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">{t('Change Permissions')}</Tooltip>}>
                                            <Button icon_sm fill disabled={!!currentId} onClick={() => onEdit(ele.module, ele.permissions)}>
                                                {editSVG({ width: 20, fillColor: '#2550AC' })}
                                            </Button>
                                        </OverlayTrigger>
                                    )}
                                </div>
                            </div>
                            <div className="card-body">
                                {displayedPerms.map((perm, i) => (
                                    <div key={`perm_${i}`}>
                                        <div className="d-flex justify-content-between align-items-center py-1">
                                            <div className="d-flex align-items-center gap-1">
                                                <span className="font-size-12">{t(perm.label)}</span>
                                                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">{t(perm.description)}</Tooltip>}>
                                                    <i className="fa fa-info-circle text-muted opacity-50 font-size-12" aria-hidden="true"></i>
                                                </OverlayTrigger>
                                            </div>
                                            <div>
                                                {isEditing ? (
                                                    <SwitchWidget
                                                        value={currentPermission.permissions[perm.value]}
                                                        onChange={checked => onPermissionChange(perm.value, checked)}
                                                    />
                                                ) : (
                                                    ele.permissions[perm.value]
                                                        ? checkCircleSVG({ width: 16, fillColor: '#16C51D' })
                                                        : crossCircleSVG({ width: 18, fillColor: '#FF0000' })
                                                )}
                                            </div>
                                        </div>
                                        {i < displayedPerms.length - 1 && <hr className="my-1" />}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default RosterPermissionsTab;
